module.exports = __webpack_public_path__ + "fonts/97180b9f69f3939579a9e44beb6578d2.svg";